import React from 'react';
import Avatar from 'antd/lib/avatar';
import Button from 'antd/lib/button';
import List from 'antd/lib/list';
import 'antd/lib/avatar/style/index.css';
import 'antd/lib/button/style/index.css';
import 'antd/lib/list/style/index.css';
import ButtonAction from 'src/pages/components/utilities/ButtonAction';
import CardJoinEmpty from './CardJoinEmpty';
var selfStyles = require('./styles.scss');
var CardJoinListEvent = function (props) {
    if (!props.events ||
        props.events.length === 0) {
        return React.createElement(CardJoinEmpty, null);
    }
    return (React.createElement(List, { className: selfStyles.list, itemLayout: 'horizontal', dataSource: props.events, renderItem: function (event) { return (React.createElement("div", { className: selfStyles.listItem },
            React.createElement("div", { className: selfStyles.listAvatar },
                React.createElement(Avatar, { shape: 'square', size: 'large', src: event.logoUrl || event.logoIdenticon })),
            React.createElement("div", { className: selfStyles.listContent },
                React.createElement("span", { className: selfStyles.listContentChild + " " + selfStyles.listContentTitle }, event.name),
                React.createElement("a", { href: "//" + event.subdomain + "." + process.env.CLIENT_HOSTNAME, target: '_blank', className: selfStyles.listContentChild }, event.subdomain + "." + process.env.CLIENT_HOSTNAME)),
            React.createElement("div", { className: selfStyles.listAction }, props.userEventRoles.find(function (uER) { return uER.eventId === event.id; })
                ? (React.createElement(ButtonAction, { width: '50px', isDisabled: true },
                    React.createElement(Button, null, "\u2713")))
                : (React.createElement(ButtonAction, { width: '50px' },
                    React.createElement(Button, { onClick: function () {
                            props.handleCreateUserEventRole({
                                userId: props.user.id,
                                eventId: event.id,
                            });
                        } }, "Join")))))); } }));
};
export default CardJoinListEvent;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/CardJoin/CardJoinListEvent.tsx
// module id = 830
// module chunks = 0